import form2 from '@/mixins/crud-form-info';
export default {
  mixins: [form2],
  data: function data() {
    return {
      api: {
        detail: 'BOX_DETAIL',
        create: 'BOX_CREATE',
        update: 'BOX_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'box_name',
        default: '',
        label: 'box_name',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.box_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "box_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'send_sms_key',
        default: '',
        label: 'send_sms_key',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.send_sms_key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "send_sms_key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'send_msg_status',
        default: '',
        label: 'send_msg_status',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict", {
            "attrs": {
              "value": _this.form.model.send_msg_status,
              "name": "send_msg_status",
              "custom": true,
              "disabled": true
            }
          });
        }
      }, {
        prop: 'used_count',
        default: '',
        label: 'used_count',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_count,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_count", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_month_count',
        default: '',
        label: 'used_month_count',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_month_count,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_month_count", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_year_count',
        default: '',
        label: 'used_year_count',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_year_count,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_year_count", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_sy',
        default: '',
        label: 'used_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_month_sy',
        default: '',
        label: 'used_month_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_month_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_month_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_year_sy',
        default: '',
        label: 'used_year_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_year_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_year_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_save_sy',
        default: '',
        label: 'used_save_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_save_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_save_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_month_save_sy',
        default: '',
        label: 'used_month_save_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_month_save_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_month_save_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_year_save_sy',
        default: '',
        label: 'used_year_save_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_year_save_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_year_save_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_get_sy',
        default: '',
        label: 'used_get_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_get_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_get_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_month_get_sy',
        default: '',
        label: 'used_month_get_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_month_get_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_month_get_sy", $$v);
              }
            }
          });
        }
      }, {
        prop: 'used_year_get_sy',
        default: '',
        label: 'used_year_get_sy',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-span", {
            "model": {
              value: _this.form.model.used_year_get_sy,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "used_year_get_sy", $$v);
              }
            }
          });
        }
      }];
    }
  }
};